import styled from '@emotion/styled';

const Div = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    border-top: 12px solid ${({ theme }) => theme.colors.blue3};
    border-bottom: 12px solid ${({ theme }) => theme.colors.blue3};
    background-color: ${({ theme }) => theme.colors.blue3};
    overflow: hidden;
    white-space: nowrap;
    width: 100%;

    > ul {
        display: flex;
        flex-shrink: 0;
        justify-content: space-around;
        animation: loopText 15s linear infinite;
        min-width: 100%;
        gap: 16px;
        margin: 0;
        padding: 12px 0;

        @keyframes loopText {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(calc(-100% - 32px));
            }
        }

        > li {
            list-style: none;
            color: ${({ theme }) => theme.colors.gray1};
            margin: 0;
            font-weight: 700;
            position: relative;
            padding-left: 26px;

            &:before {
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 10px;
                height: 10px;
                background-color: ${({ theme }) => theme.colors.gray1};
                border-radius: 50%;
            }
        }
    }

    @media (min-width: 1280px) {
  gap: 32px;

  > ul {
    gap: 32px;
    
    > li {
      font-size: 1.125rem;
      padding-left: 44px;

      &:before {
        width: 12px;
        height: 12px;
      }
    }
}
`;

export const Marquee = () => {
    return (
        <Div>
            <ul>
                <li>Commercial Upgrades</li>
                <li>Commercial Renovations</li>
                <li>Tenant Improvements</li>
                <li>Interior Buildouts</li>
                <li>Office Renovations</li>
                <li>Retail Buildouts</li>
                <li>Commercial Upgrades</li>
                <li>Commercial Renovations</li>
                <li>Tenant Improvements</li>
                <li>Interior Buildouts</li>
                <li>Office Renovations</li>
                <li>Retail Buildouts</li>
            </ul>

            <ul aria-label="hidden">
                <li>Commercial Upgrades</li>
                <li>Commercial Renovations</li>
                <li>Tenant Improvements</li>
                <li>Interior Buildouts</li>
                <li>Office Renovations</li>
                <li>Retail Buildouts</li>
                <li>Commercial Upgrades</li>
                <li>Commercial Renovations</li>
                <li>Tenant Improvements</li>
                <li>Interior Buildouts</li>
                <li>Office Renovations</li>
                <li>Retail Buildouts</li>
            </ul>
        </Div>
    );
};
